var getLockTime = function getLockTime(time) {
  return time ? Math.ceil(time / 60) : "";
};

/** 解析验证码错误提示...*/
export function parseVerifyCodeErrorMsg(errorMsg, $st) {
  if (errorMsg) {
    if (errorMsg.includes("type=otp")) {
      return "".concat($st("withdraw_code_verify_failed_google"));
    }
    if (errorMsg.includes("type=sms")) {
      return "".concat($st("sms_verify_code_error"));
    }
    if (errorMsg.includes("type=email")) {
      return "".concat($st("email_verify_code_error"));
    }
    if (errorMsg.includes("type=voice")) {
      return "".concat($st("voice_verify_code_error"));
    }
  }
  return "".concat($st("verification_code_error"));
}
export function parseAccountError(error, $st) {
  if (!error) {
    return "Unknown error";
  }
  var code = error.code,
    data = error.data,
    message = error.message;
  if (code === -2 || code === -3 || code === -9206) {
    // 会话超时
    return $st("account_session_timeout");
  } else if (code === -4) {
    // 发送验证码太频繁
    return $st("verification_code_send_too_quick");
  } else if (code === -4209) {
    return $st("verification_code_error");
  } else if (code === -2003 || code === -24004 || code === -100001) {
    // -24004 老账号注册，获取验证码时提示账号已存在
    return $st("account_already_exists");
  } else if (code === -3300) {
    return $st("acc_mail_cn_tip");
  } else if (code === -1203 || code === -1204) {
    return $st("sign_in_account_not_exists");
  } else if (code === -8209) {
    var un_used = data === null || data === void 0 ? void 0 : data.un_used;
    if (un_used === undefined) {
      //账号错误
      return $st("account_verify_error_1");
    } else {
      var _data$incr_ex;
      //账号正确
      var lockTime = Math.ceil(((_data$incr_ex = data === null || data === void 0 ? void 0 : data.incr_ex) !== null && _data$incr_ex !== void 0 ? _data$incr_ex : 1800) / 60).toString();
      if (un_used === 0) {
        //密码错误超过5次
        return $st("account_locked_error_signIn", {
          time: lockTime
        });
      } else {
        // 密码错误小于5次
        return "".concat($st("account_verify_error_1")).concat($st("account_chance_error_signIn", {
          count: un_used,
          time: lockTime
        }));
      }
    }
  } else if (code === -109907) {
    var _data$incr_ex2;
    // 账号正确，密码输错5次被锁定以后，又输入了正确的账号和密码
    var _lockTime = Math.ceil(((_data$incr_ex2 = data === null || data === void 0 ? void 0 : data.incr_ex) !== null && _data$incr_ex2 !== void 0 ? _data$incr_ex2 : 1800) / 60).toString();
    return $st("account_locked_error_signIn", {
      time: _lockTime
    });
  } else if (code === -5203) {
    // Google两步验证失败
    return $st("verification_code_error");
  } else if (code === -99999) {
    // 403
    return $st("account_too_many_requests");
  } else if (code === -99998) {
    // network request time out
    return $st("network_error");
  } else if (message === "Network request failed") {
    return "".concat($st("network_error"), ".");
  } else if (code === -99900 && message.indexOf("Network Error") !== -1) {
    return "".concat($st("network_error"), "..");
  } else if (code === -4212) {
    var _un_used = data === null || data === void 0 ? void 0 : data.un_used;
    if (_un_used === undefined) {
      return $st("verification_code_error");
    } else if (_un_used === 0) {
      var _data$incr_ex3;
      return $st("account_locked_error_signIn", {
        time: getLockTime((_data$incr_ex3 = data === null || data === void 0 ? void 0 : data.incr_ex) !== null && _data$incr_ex3 !== void 0 ? _data$incr_ex3 : 1800)
      });
    } else {
      var _data$incr_ex4;
      return "".concat($st("verification_code_error"), " ").concat($st("account_chance_error_signIn", {
        count: _un_used,
        time: getLockTime((_data$incr_ex4 = data === null || data === void 0 ? void 0 : data.incr_ex) !== null && _data$incr_ex4 !== void 0 ? _data$incr_ex4 : 1800)
      }));
    }
  } else if (code === -46210) {
    return "".concat($st("ga_unbind_too_quick_error"));
  } else if (code === -1009) {
    return "".concat($st("account_signin_error_stuck_temp"));
  } else if (code === 40920642) {
    return $st("credit_card_error_too_many_request");
  } else if (code === 40320708) {
    return "Sorry! Looks like this service is not available in your current location(IP).";
  } else if (code === 50021343) {
    return "The error of Service Provider";
  } else if (code === -109902) {
    return $st("withdraw_verify_code_sent_error");
  } else if (code === -109903) {
    var _un_used2 = data === null || data === void 0 ? void 0 : data.un_used; // 剩余重试次数
    if (_un_used2 === undefined) {
      return $st("code_verify_error");
    } else if (_un_used2 === 0) {
      var _data$incr_ex5;
      return $st("account_locked_error_signIn", {
        time: getLockTime((_data$incr_ex5 = data === null || data === void 0 ? void 0 : data.incr_ex) !== null && _data$incr_ex5 !== void 0 ? _data$incr_ex5 : 1800)
      });
    } else {
      var _data$incr_ex6;
      return "".concat(parseVerifyCodeErrorMsg(message, $st), " ").concat($st("account_chance_error_signIn", {
        count: _un_used2,
        time: getLockTime((_data$incr_ex6 = data === null || data === void 0 ? void 0 : data.incr_ex) !== null && _data$incr_ex6 !== void 0 ? _data$incr_ex6 : 1800)
      }));
    }
  } else if (code === -100502) {
    return $st("ga_reset_question_had_submitted");
  } else if (code === -100501) {
    return $st("ga_reset_question_had_submitted");
  } else if (code === -32003) {
    return $st("account_user_not_exists");
  } else if (code === -3301) {
    return $st("account_signUp_bind_3301_error");
  } else if (code === -109907) {
    var _data$incr_ex7;
    return "".concat($st("account_locked_error", {
      minutes: getLockTime((_data$incr_ex7 = data === null || data === void 0 ? void 0 : data.incr_ex) !== null && _data$incr_ex7 !== void 0 ? _data$incr_ex7 : 1800)
    }));
  } else if (code === -13201) {
    return $st("account_bind_2fa_before_unbind");
  } else if (code === -101030) {
    return $st("hyperlink_expired");
  } else {
    if (!code) {
      console.log(error);
      return $st("trade_error_unknown");
    }
    return "".concat(code, ": ").concat(message);
  }
}